import { Attr, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";
import { Matrix4, Vector3 } from "three";


type TransformAttrs = {
    normal?: Attr;
};

const v = new Vector3();

export class RigidTransformMesh<T extends TransformAttrs> extends IndexedMeshWriter<T> {

    matrix: Matrix4;
    normalMatrix: Matrix4;
    writer: IndexedMeshWriter<TransformAttrs>

    /**
     * @param matrix - note that this class is using a conventional transform
     * to rotate the normals, which will produce incorrect results if there
     * is any scale factor in the transform.
     */
    constructor(matrix: Matrix4, writer: IndexedMeshWriter<TransformAttrs>) {
        super();
        this.matrix = matrix;
        this.normalMatrix = matrix.clone();
        this.normalMatrix.setPosition(0, 0, 0);
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T> {
        return this.writer.computeAttributeCounts() as IndexedMesh<T>;
    }

    computeMeshData(result: IndexedMesh<T>): void {
        this.writer.computeMeshData(result);
    
        const pos = result.position.data;
        let i = 0;
        while(i < pos.length) {
            v.set(pos[i], pos[i+1], pos[i+2]);
            v.applyMatrix4(this.matrix);
            pos[i++] = v.x; pos[i++] = v.y; pos[i++] = v.z;
        }

        if(result.attrs.normal != null) {
            const norm = result.attrs.normal.data;

            let i = 0;
            while(i < norm.length) {
                v.set(norm[i], norm[i+1], norm[i+2]);
                v.applyMatrix4(this.normalMatrix);
                norm[i++] = v.x; norm[i++] = v.y; norm[i++] = v.z;
            }
        }
        
    }
}
